document.addEventListener("alpine:init", () => {
  Alpine.data("generalSettingsController", () => ({
    init() {
      window.addEventListener(
        "beforeunload",
        function(e) {
          let allChangesSaved = this.$store.postContent.isEqualTo(
            document.getElementById("after-post-content").value,
          );
          // Only send a warning if we have unsaved changes
          if (!allChangesSaved) {
            e.preventDefault();
            e.returnValue = "";
          }
        }.bind(this),
      );
    },

    submit() {
      document.getElementById("after-post-content").value =
        this.$store.postContent.get();
      return false;
    },
  }));
});
